module.exports = __webpack_public_path__ + "static/fun-time/audio/karta1//3_Tom.mp3";